import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {observable, makeObservable} from 'mobx';

import FormLabel from './form-label';

@observer
export default class RadioGroup extends React.Component {

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  static propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
    updateValue: PropTypes.func.isRequired,
    required: PropTypes.bool,
    labelText: PropTypes.string,
    helperText: PropTypes.string,
    optionsList: PropTypes.array,
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
    showErrorDirectiveFromMaster: PropTypes.bool
  }

  static defaultProps = {
    value: '',
    optionsList: [],
    labelText: '',
    helperText: '',
    required: false,
    disabled: false,
    errorMessage: 'Please select one of the options.',
    className: '',
    showErrorDirectiveFromMaster: false
  }

  componentDidUpdate() {
    if(this.props.required && this.props.showErrorDirectiveFromMaster === true) {
      this.hasVisibleError = this.hasFunctionalError;
    }
  }

  @observable hasVisibleError = false;
  get hasFunctionalError() {
    return this.props.required && this.props.value === '';
  }

  handleOnChange = (e) => {
    if(!this.props.disabled) {
      this.props.updateValue(e.target.value);
    }

    /* FPSE-1997 Even though we usually don't validate on change for App Control,
    we should remove an existing error if the user picks an option. */
    this.hasVisibleError = false;
  }

  handleOnBlur = () => {
    // Currently do not validate on blur for App Control
    // this.hasVisibleError = this.hasFunctionalError;
  }

  focus = () => {
    this.firstInput.focus();
  }

  renderRadioInputs = () => {
    return this.props.optionsList.map((option, index) => {
      const trueValue = option.hiddenValue || option.title;
      const uniqueKey = 'radioOption' + trueValue;
      return (<label key={uniqueKey}>
        <input type="radio"
          name={this.props.id}
          ref={i => {if(index === 0) {this.firstInput = i}}}
          value={trueValue}
          disabled={this.props.disabled}
          checked={this.props.value === trueValue}
          onChange={this.handleOnChange}/>
        {option.title}
        <span className="cr"></span>
        {option.additionalJsx}
      </label>);
    });
  }

  render() {
    const disabledClass = this.props.disabled
      ? 'disabled'
      : '';
    return (
      <fieldset id={this.props.id} className={`form-group radio ${this.props.className} ${disabledClass} ${this.hasVisibleError ? 'has-error' : ''}`} onBlur={this.handleOnBlur}>
        <FormLabel
          hasError={this.hasVisibleError}
          fieldIsRequired={this.props.required}
          labelText={this.props.labelText}
          helperText={this.props.helperText}
          errorMessage={this.props.errorMessage} />
        <div className="radio-inputs">
          {this.renderRadioInputs()}
        </div>
      </fieldset>
    )
  }
}
